import React, { forwardRef } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import './AddButton.scss';

const AddButton = forwardRef((props, ref) => {
  const {
    className = '',
    label = 'Add Block of business',
    ...restProps
  } = props;
  return (
    <div
      className={`add-button-container ${
        props.containerClassName ? props.containerClassName : ''
      }`}
    >
      <GenericButton
        ref={ref}
        variant="addbutton"
        className={className ? `add-button ${className}` : 'add-button'}
        {...restProps}
      >
        <PlusOutlined /> {label}
      </GenericButton>
    </div>
  );
});

export default AddButton;
